import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairRegisterModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffGradFairRegisterModalContainer" */
      './StaffGradFairRegisterModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
